import { ReactComponent as DayComponent } from '@src/assets/images/icons/component.svg'
import { ReactComponent as DayTour } from '@src/assets/images/icons/day-tour.svg'
import { ReactComponent as MutliDayTour } from '@src/assets/images/icons/multi-day-tour.svg'
import { Grid, Users, Layers } from "react-feather"

export const dropdownConfig = [
    {
        id: "Itinerary",
        url: '/ItineraryBuilder/Personal',
        label: 'Itinerary',
        defaultValue: 'Create itinerary',
        heading: 'Create a new itinerary',
        subparagraph: 'What type of itinerary would you like to create?',
        subOptions: [
            {
                id: 'personal-itinerary',
                title: 'Personal Itinerary',
                icon: <Users size={18} />,
                paragraph: 'A customized itinerary tailored to a specific client or group, including their travel dates and personal details.',
                url: '/Builder/Build/Personal/ItineraryDetails'
            },
            {
                id: 'sample-itinerary',
                title: 'Sample Itinerary',
                icon: <Grid size={18} />,
                paragraph: 'A general example of a trip, often used to showcase packages or scheduled departures without fixed traveler details.',
                url: '/Builder/Build/Sample/ItineraryDetails'
            }
        ]
    },
    {
        id: "Tour",
        url: '/ItineraryBuilder/Personal',
        label: 'Tour',
        defaultValue: 'Create tour',
        heading: 'Create a new tour',
        subparagraph: 'What type of tour would you like to create?',
        subOptions: [
            {
                id: 'day-tour',
                title: 'Day Tour',
                icon: <DayTour />,
                paragraph: 'Single-day travel experiences to specific destinations or attractions, returning to the starting point the same day.',
                url: '/Builder/Build/DayTour/ItineraryDetails'
            },
            {
                id: 'multi-day-tour',
                title: 'Multi-day tour',
                icon: <MutliDayTour />,
                paragraph: 'Extended travel experiences spanning multiple days, including overnight stays.',
                url: '/Builder/Build/MultiDayTours/ItineraryDetails'
            }
        ]
    },
    {
        id: "Component",
        url: '/ItineraryBuilder/Personal',
        label: 'Component',
        defaultValue: 'Create component',
        heading: 'Create a new component',
        subparagraph: "What type of component would you like to create?",
        subOptions: [
            {
                id: 'day-component',
                title: 'Day component',
                icon: <DayComponent />,
                paragraph: 'A reusable block with activities and details for one day, that can be added to itineraries - saving you the effort of duplicating frequently added information.',
                url: '/Builder/Build/DayComponent/ComponentDetails'
            },
            {
                id: 'multi-day-component',
                title: 'Multi-day component',
                icon: <Layers size={18} />,
                paragraph: 'A reusable block with activities and details for multiple days, that can be added to itineraries - saving you the effort of duplicating frequently added information.',
                url: '/Builder/Build/MultiDayComponent/ComponentDetails'
            }
        ]
    }
]